import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import API_URL from "../../../redux2";
import {
  ONE_DAY_CREDIT,
  WALLET_MINIMUM_AMOUNT,
} from "../../../common/constants";
import { issueAirArabiaTicket } from "../Service/AirarabiaApi";
import PaymentMethodModal from "../../../Pages/Trips/components/PaymentMethodModal";
import Loading from "../../Loading";

const IssueAirArabiaPayLater = ({ user, booking, currency }) => {
  const [show, setShow] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [loading, setLoading] = useState(false);
  const [payment, setPayment] = useState(null);
  const [error, setError] = useState(null);
  const [selectedCorporate, setSelectedCorporate] = useState(null);

  const initiatePayment = async () => {
    if (!paymentMethod) return toast.error("Please select payment method");

    if (!booking?.company && paymentMethod === "credit") {
      if (!selectedCorporate) {
        toast.error("Please select corporate");
        return;
      }
    }

    if (paymentMethod === "wallet") {
      payWithWallet();
      return;
    }

    if (paymentMethod === "credit" || paymentMethod === "USDCredit") {
      payWithCredit();
      return;
    }

    const data = {
      pnr: booking?.flight?.PNR,
      paymentMethod,
    };

    setLoading(true);
    try {
      const res = await axios.post(API_URL + "booking/payment/initiate", data);

      setPayment(res?.data?.data);
    } catch (err) {
      console.log(err);
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleIssueTicketModal = () => {
    setShow(true);
  };

  let instructions = [];
  if (payment?.paymentInstructionsAll) {
    instructions = payment?.paymentInstructionsAll;
  } else {
    instructions = payment?.paymentInstructions;
  }

  function payWithWallet() {
    if (
      booking.company &&
      paymentMethod === "wallet" &&
      booking?.company.wallet <
        (booking?.company?.ADMLimit || WALLET_MINIMUM_AMOUNT) +
          booking?.flight?.price +
          booking?.serviceCharge
    ) {
      toast.error(
        `You can't use wallet for payment. You don't have enough balance. Please use other payment method.`,
      );
      return;
    }

    setLoading(true);
    getTicket("wallet")
      .then((res) => {
        if (res.errors) {
          console.log(res);
          setError(res?.TicketFailureInfo?._attributes?.Message);
          setLoading(false);
        } else {
          setLoading(false);
          toast.success("Booking Successful");

          setTimeout(() => {
            setShow(false);
            window.location.reload();
          }, 700);

          return;
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }

  function payWithCredit() {
    if (
      booking.company &&
      booking.company.creditType === ONE_DAY_CREDIT &&
      booking.company.creditLimit < booking?.flight?.price &&
      paymentMethod === "credit"
    ) {
      toast.error(
        `You can't use credit for payment. You don't have enough credit limit. Please use other payment method.`,
      );
      return;
    }

    if (
      booking.company &&
      paymentMethod === "USDCredit" &&
      booking.company.USDCreditLimit < booking?.flight?.USDPrice
    ) {
      toast.error(
        `You can't use credit for payment. You don't have enough credit limit. Please use other payment method.`,
      );
      return;
    }

    setLoading(true);
    getTicket(paymentMethod ?? "credit")
      .then((res) => {
        if (res.errors) {
          console.log(res);
          setError(res?.TicketFailureInfo?._attributes?.Message);
          setLoading(false);
        } else {
          setLoading(false);
          toast.success("Booking Successful");

          setTimeout(() => {
            setShow(false);
            window.location.reload();
          }, 700);

          return;
        }
      })
      .catch((err) => {
        console.log(err);
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        }
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const getTicket = async (paymentType, otp = "") =>
    new Promise(async (resolve, reject) => {
      let data = {
        id: booking?._id,
        pnr: booking?.flight?.PNR,
        payment: paymentMethod || "wallet",
        otp: otp || null,
        corporateName: selectedCorporate || null,
        userId: user?._id,
        companyId: booking?.company?._id,
        // amount: reservation?.price?.totalFare?.amount,
        // decimalPlaces: reservation?.price?.totalFare?.decimalPlaces || "2",
        // currency: reservation?.price?.totalFare?.currency,
      };

      const response = await issueAirArabiaTicket(data, setLoading);
      console.log({ response });

      if (response?.data?.errors) {
        setError(response?.data?.errors?.[0]?.message);
        reject(response?.data?.errors);
      }

      resolve(response?.data);
    });

  useEffect(() => {
    if (error) {
      toast.error(error);
      setError(null);
    }
  }, [error]);

  const renderInstructions = () => {
    return (
      <div className="p-6 mt-2 sm:space-y-1 sm:p-6 xl:px-8 xl:py-1">
        <div className="flex flex-col tracking-wider">
          {instructions?.map((item, index) => (
            <div key={index}>
              <h1 className="text-xl font-semibold text-center underline">
                {item?.type}
              </h1>
              <div key={index} className="flex items-start">
                <div className="flex flex-col">
                  {item?.instructions?.map((instruction, i) => (
                    <span
                      className="text-sm font-semibold text-neutral-900"
                      key={i}
                    >
                      {instruction}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div>
      <div
        className="pt-3 cursor-pointer dropdown-item"
        onClick={handleIssueTicketModal}
      >
        Issue Ticket
      </div>
      <div className="px-4 bg-white">
        <Modal
          show={show}
          onHide={() => {
            setShow(false);
          }}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="modal-right"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Payment Method
            </Modal.Title>
          </Modal.Header>

          {loading ? (
            <Loading search />
          ) : (
            !payment?.paymentInstructions && (
              <PaymentMethodModal
                paymentMethod={paymentMethod}
                setPaymentMethod={setPaymentMethod}
                // enterprise={enterprise}
                company={booking.company}
                booking={booking}
                user={user}
                totalPrice={
                  currency === "USD"
                    ? booking?.USDTotalPrice
                    : booking?.flight?.price + booking?.serviceCharge || 0
                }
                selectedCorporate={selectedCorporate}
                setSelectedCorporate={setSelectedCorporate}
                currency={currency}
              />
            )
          )}

          {paymentMethod !== "wallet" &&
            paymentMethod !== "credit" &&
            paymentMethod !== "USDCredit" &&
            payment && (
              <>
                {loading && <Loading />}
                <div className="p-5">
                  <h1 className="text-2xl text-center capitalize font bold">
                    {paymentMethod}
                  </h1>
                  <div className="flex flex-wrap justify-center px-2 my-2">
                    <button
                      className="px-2 py-1 text-white rounded-lg cursor-pointer bg-slate-300"
                      onClick={() => {
                        navigator.clipboard.writeText(
                          payment?.paymentReference,
                        );
                        toast.success(
                          "Payment Reference code copied to clipboard",
                        );
                      }}
                    >
                      <h1 className="flex text-xl font-bold">
                        {payment?.paymentReference}
                        <button className="mx-2 hover:text-green-800 hover:rounded-full">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-6 h-6"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z"
                            />
                          </svg>
                        </button>
                      </h1>
                    </button>
                  </div>
                  {renderInstructions()}
                </div>
              </>
            )}

          <Modal.Footer>
            <div className="flex gap-4 justify-end items-center w-full">
              <button
                type="button"
                className="text-white btn bg-main hover:bg-main-800 border-main-100 disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={initiatePayment}
              >
                Pay
              </button>

              <button
                type="button"
                className="text-white bg-red-500 btn hover:bg-red-500/80 border-main-100"
                onClick={() => {
                  setShow(false);
                }}
              >
                Close
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default IssueAirArabiaPayLater;
